// extracted by mini-css-extract-plugin
export default {"root":"manageRoles_root__Iy33Y"};